"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Chat extends base_1.default {
    list() {
        return this.get('chat/list');
    }
    postMessage(data) {
        return this.post('chat/message', data);
    }
    getMessages(case_id) {
        return this.get(`chat/messages?case_id=${case_id}`, {});
    }
    attachFile(data) {
        return this.upload('chat/attach-file', data);
    }
    deleteMessage(message_id) {
        return this.post('/chat/message/delete', { message_id });
    }
    markAsRead(data) {
        return this.post('chat/mark-as-read', data);
    }
    getFile(fileUrl) {
        return this.getFileByFullUrl(fileUrl);
    }
}
exports.default = new Chat();
